/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string, bool, arrayOf,
    number, object, func,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles';
import { combineStyle } from '../../../style/combineStyle';
import { deepObjectExtend, isEmpty } from '../../../utils/object';
import { main as MainStyle } from '../../../style/main';
import { form as FormStyle } from '../../../style/form';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';
import AccountLeftMenu from '../../../common/Desktop/AccountLeftMenu';
import { getFeatureFlags } from '../../../utils/featureSelectors';
import { DesktopAddressBookStyle } from '../../../style/DesktopAddressBookStyle';
import DesktopAddressList from './DesktopAddressList';
import DesktopAddressDetail from './DesktopAddressDetail';
import DesktopAddressForm from './DesktopAddressForm';
import DesktopAddressAddForm from './DesktopAddressAddForm';

const { PERSIST_KEY } = configENV;
const styles = ({ typography, palette }) => deepObjectExtend(
    combineStyle(typography, palette, {
        MainStyle,
        FormStyle,
        DesktopAddressBookStyle,
    }),
);

class DesktopAddressBook extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAddNewAddressClicked: false,
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { handleDesktopAddNewRecipient, fetchUserProfile } = this.props;
        handleDesktopAddNewRecipient();
        fetchUserProfile();
    };

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    handleDesktopAddNewAddress = () => {
        const { handleDesktopAddNewFormClicked } = this.props;
        this.setState({ isAddNewAddressClicked: true });
        handleDesktopAddNewFormClicked();
    };

    render() {
        const {
            classes, userProfile, featureFlags,
            addForm, recipients,
        } = this.props;
        const { isAddNewAddressClicked } = this.state;
        const showForm = !isEmpty(recipients) || isAddNewAddressClicked;
        return (
            <>
                <Grid className={`container ${classes.DesktopAddressBookStyle}`} container>
                    <AccountLeftMenu
                        userProfile={userProfile}
                        featureFlags={featureFlags}
                    />
                    <Grid item xs={10} style={{ padding: '40px 11px 0 43px' }}>
                        <div className="position-relative">
                            <h2 className="float-left">Contacts</h2>
                            <span className={`float-right small gray-color ${!showForm ? 'display-none' : ''}`}>* Required Field</span>
                        </div>
                        <Grid className="shadowContentGrid contentGrid" container item xs={12}>
                            <Grid item xs={showForm ? 5 : 12} className="display-flex column">
                                <DesktopAddressList />
                                <div className={`addNewAddressWrapper ${!showForm ? 'empty' : ''}`}>
                                    <Button
                                        className=""
                                        onClick={() => this.handleDesktopAddNewAddress()}
                                    >
                                        Add New Address
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={7} className={`addressDetailsWrapper ${!showForm ? 'display-none' : ''}`}>
                                {
                                    (addForm === 'AddForm') ? <DesktopAddressAddForm /> : null
                                }
                                {
                                    (addForm === 'EditForm') ? <DesktopAddressForm /> : null
                                }
                                <DesktopAddressDetail addForm={addForm} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </>
        );
    }
}

DesktopAddressBook.defaultProps = {
    handleDesktopAddNewRecipient: () => { },
    handleDesktopAddNewFormClicked: () => { },
    userProfile: {},
    featureFlags: {},
    addForm: '',
    recipients: [],
};

DesktopAddressBook.propTypes = {
    classes: object.isRequired,
    handleDesktopAddNewRecipient: func,
    handleDesktopAddNewFormClicked: func,
    addForm: string,
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
        XAtt4: string,
        XAtt5: string,
    }),
    recipients: arrayOf(
        shape({
            AddressBookEntryId: string,
            ContactId: number,
            FirstName: string,
            LastName: string,
            RelationShip: string,
            NickName: string,
            LastUpdateDate: string,
            EmployerName: string,
            NumberOfAddresses: number,
            Addresses: arrayOf(
                shape({
                    AddressId: number,
                    AddressBookEntryId: string,
                    AddressType: string,
                    AddressLineOne: string,
                    AddressLineTwo: string,
                    City: string,
                    StateProvince: string,
                    PostalCode: string,
                    Country: string,
                    ContactId: number,
                }),
            ),
        }),
    ),
    fetchUserProfile: func.isRequired,
    featureFlags: object,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    let featureFlags = {};
    if (state.app) {
        try {
            featureFlags = {
                ...getFeatureFlags(state),
            };
            // eslint-disable-next-line no-empty
        } catch (ex) {}
    }
    return {
        addFormLable: newState.addFormLable,
        addForm: newState.addForm,
        recipients: newState.recipients,
        featureFlags,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchUserProfile: () => dispatch(EventDispatcher.fetchUserProfile()),
    handleDesktopAddNewRecipient: () => dispatch(EventDispatcher.handleDesktopAddNewRecipient()),
    handleDesktopAddNewFormClicked: () => dispatch(EventDispatcher.handleDesktopAddNewFormClicked('RecipientForm')),
    // handleCloseDialog: () => dispatch(EventDispatcher.handleCloseDialog()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(DesktopAddressBook)));
